import QRCode from 'react-qr-code';

const QRCodeData = ({ value, style }) => (
  <QRCode size={256} style={style} value={value} viewBox={`0 0 256 256`} />
);

export default QRCodeData;
